import React from "react";
import { useAppSelector } from "../../../../../app/hooks";
import { TextField } from "@mui/material";
import { formatNumber } from "@progress/kendo-intl";

function AccountInsurancePaymentsView(){
    const account = useAppSelector((state) => state.account.account);
    return <React.Fragment>
        <TextField label='Insurance Payments' 
            value={formatNumber(account.transactionHeader.insurancePayments,'c')}
            disabled
            />
    </React.Fragment>
}
export {AccountInsurancePaymentsView}